<!--<div class="dashboar-header">-->
<!--    <div class="container-responsive narrow">-->

<!--        <div class="d-flex justify-content-between">-->
<!--            <app-products-box></app-products-box>-->

<!--            <app-sales-concierge-box class="sales-concierge-box" *ngIf="isSalesConcierge"-->
<!--                                     (buttonClicked)="onHtmlItemClicked(TrackingCalledSectionDashboardEnum.HOME_SALES_CONCIERGE)">-->
<!--            </app-sales-concierge-box>-->
<!--        </div>-->
<!--    </div>-->
<!--</div>-->


<div class="container-responsive narrow">
    <div class="boxes-container">

        <app-custom-box [headlineHtml]="'Sales Dashboard'"
                        [descriptionHtml]="'Aktueller Stand über alle Sales Programme im Zuge des laufenden Geschäftsjahres'"
                        [buttonText]="'Zum Sales Dashboard'"
                        [link]="'/sales-dashboard'"
                        class="small-height">
        </app-custom-box>

<!--        <ng-container *ngIf="gAuthData.cspAllowed || gAuthData.cspConnectedAllowed">-->
        <ng-container *ngIf="userContextService.hasPermission(SecFEPermissionPartnerAppEnum.__PAU_CONTRACTS)">
<!--            <app-custom-box *ngIf="gAuthData.cspAllowed || gAuthData.isCspReadOnly"-->
            <app-custom-box *ngIf="userContextService.hasPermission([SecFEPermissionPartnerAppEnum.__PAU_CONTRACTS_CSP])"
                            [headlineHtml]="'CSP Verträge'" [boxSize]="'xlarge'"
                            class="small-height"
                            [descriptionHtml]="'Erstellung und Administration von CSP (Consumables Support Programm) Verträgen'"
                            [link]="'/print-smart/csp'"
                            [buttonText]="'Zu den CSP Verträgen'">

            </app-custom-box>

<!--            <app-custom-box *ngIf="gAuthData.cspConnectedAllowed"-->
            <app-custom-box *ngIf="userContextService.hasPermission(SecFEPermissionPartnerAppEnum.PAU_CONTRACTS_CSP_CONNECTED)"
                            [headlineHtml]="'CSP Connected Verträge'"
                            [descriptionHtml]="'Erstellung und Administration von CSP Connected Verträgen'"
                            [buttonText]="'Zu den CSP Connected Verträgen'"
                            [link]="'/print-smart/csp_connected'"
                            class="small-height">
            </app-custom-box>
        </ng-container>

<!--        <app-custom-box *ngIf="gAuthData.projectManagementAllowed"-->
        <app-custom-box *ngIf="userContextService.hasPermission(SecFEPermissionPartnerAppEnum.PAU_PROJECTS)"
                        [headlineHtml]="'Projektgeschäft'"
                        [descriptionHtml]="'Anfragen Projektkonditionen, Übersicht bisheriger Projekte'"
                        [buttonText]="'Zu den Projekten'"
                        [link]="'/projects'"
                        class="small-height">
        </app-custom-box>

        <app-custom-box [headlineHtml]="'News und Aktionen'"
                        [descriptionHtml]="'Übersicht versendeter Newsletter zu Themen  wie Monatsangebote, Informationen zu Produkten und Web-Seminaren'"
                        [buttonText]="'News'"
                        [link]="'/news'"
                        class="small-height">
        </app-custom-box>

        <app-custom-box [headlineHtml]="'Dokumentenkorb'"
                        [descriptionHtml]="'Übersicht gültiger Dokumente wie Nutzungsbedingungen und Teilnahmebedingungen'"
                        [buttonText]="'Zum Dokumentenkorb'"
                        [link]="'/document-basket'"
                        class="small-height">
        </app-custom-box>


        <div *ngIf="userContextService.hasPermission(SecFEPermissionPartnerAppEnum.PAU_SERVICE)">
            <!--        service-->
            <app-custom-box [headlineHtml]="'Trainingswebsite<br>&quot;Service Schulungsseite&quot;'"
                            [descriptionHtml]="'Zugang zum Brother Service Training für Service Partner'"
                            [buttonText]="'Zur Trainingswebsite'"
                            (buttonClick)="onServiceBoxClick(secureLink)"
                            class="small-height">
            </app-custom-box>
            <a target="_blank" referrerpolicy="no-referrer-when-downgrade" #secureLink class="d-none"></a>
        </div>

        <app-custom-box [headlineHtml]="'Kontakt'"
                        [descriptionHtml]="'Ihr Ansprechpartner bei Brother'"
                        [buttonText]="'Brother Ansprechpartner'"
                        [link]="'/contact'"
                        class="small-height">
        </app-custom-box>


    </div>
</div>


<app-credentials-modal></app-credentials-modal>
